import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(auth)/_layout')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="bg-surface-2 h-svh grid place-items-center grow">
      <Outlet />
    </div>
  );
}
